'use client';

import { c as _c } from "react/compiler-runtime";
import { GoogleReCaptchaCheckbox } from '@google-recaptcha/react';
import { forwardRef, useImperativeHandle, useRef } from 'react';
export interface RecaptchaCheckboxRef {
  getToken: () => string | null;
}

// Isolated into its own component on purpose: the underlying widget tears down
// and re-creates (a visible flicker) whenever its `onChange` *reference* changes
// — its internal useEffect lists onChange as a dependency. A parent auth form
// re-renders on every keystroke, so an inline onChange there churns. Here the
// callback only touches a LOCAL ref, so the React compiler keeps it stable and
// the widget mounts once. The token is read imperatively via the ref rather than
// pushed through a callback prop (a parent callback would itself be unstable and
// reintroduce the churn; mutating a ref passed in as a prop is also disallowed
// by the compiler).
export const RecaptchaCheckbox = forwardRef<RecaptchaCheckboxRef>(function RecaptchaCheckbox(_props, ref) {
  const $ = _c(2);
  const tokenRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => ({
      getToken: () => tokenRef.current
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useImperativeHandle(ref, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <GoogleReCaptchaCheckbox onChange={token => {
      tokenRef.current = token;
    }} onExpired={() => {
      tokenRef.current = null;
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
});